import { render, staticRenderFns } from "./SAccFreetrial.vue?vue&type=template&id=20a1ea2f&scoped=true"
import script from "./SAccFreetrial.vue?vue&type=script&lang=ts"
export * from "./SAccFreetrial.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a1ea2f",
  null
  
)

export default component.exports